import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  goToPage(page: any) {
    this.router.navigateByUrl(page.path);
  }

  goToCalendly(){
    window.open('https://calendly.com/voy-jaleas/30min?month=2023-02', '_blank');
  }

}
